var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"giftCategory","resourceName":"Geschenkkategorie","original":_vm.original,"attributes":[
      {
        name: 'name',
        label: 'Name'
      },
      {
        name: 'active',
        label: 'Aktiv',
        type: 'CheckboxSelector'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Geschenkkategorie bearbeiten")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }